export default __webpack_public_path__ + "static/media/success.aede664b.gif";